import React from 'react'
// import { useNavigate } from 'react-router-dom';

const Admin = () => {
  // const navigate = useNavigate()
  return (
    <div>Admin</div>
  )
}

export default Admin